import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var toggleDeviceLoggingWindow = mutatorAction('toggleDeviceLoggingWindow', function () {
    var store = mobileDeviceFullStore();
    store.isLoggingOpen = !store.isLoggingOpen;
});
//# sourceMappingURL=toggleDeviceLoggingWindow.js.map